export default __webpack_public_path__ + "static/media/pyIcons.678a5f9d.svg";